import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { IAxiosRetryConfigExtended,  } from 'axios-retry';
import axiosRetry from 'axios-retry';
import { createBrowserHistory } from 'history';

import { getCookie, setCookie} from './cookie';
declare module 'axios' {
  export interface AxiosRequestConfig {
    'axios-retry'?: IAxiosRetryConfigExtended;
    omitAuth?: boolean;
  }
}

export const API_BASE_AWS = "https://8vjqrpkdei.execute-api.us-east-1.amazonaws.com";
export const API_BASE_LOCAL = "http://localhost:8000/api";
export const API_BASE_AUTH = "https://8vjqrpkdei.execute-api.us-east-1.amazonaws.com/api";
export const API_BASE_FRONTDESK24 = "https://api.frontdesk24.com";

export const baseURL = `${API_BASE_FRONTDESK24}/api`;

console.log('API Base URL configured as:', baseURL);

export const axiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  
  },
});

const axiosInstanceLocal = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});



const RETRY_COUNT = 0;
/*
axiosRetry(axiosInstance, {
  retries: RETRY_COUNT,
  retryDelay: (retryCount) => {
    return retryCount * 1000;
  },
  retryCondition: (error) => {
    if (error?.response?.config?.url?.startsWith("auths/")) {
      return false;
    }
    return Number(error.response?.status) >= 500;
  },
});
*/

function request<T>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> {
  return axiosInstance.request<T>(config);
}

function requestLocal<T>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> {
  return axiosInstanceLocal.request<T>(config);
}

async function refreshAccessToken(): Promise<string | null> {
  try {
    const refreshToken = localStorage.getItem('refreshToken');
    if (!refreshToken) {
      console.log('No refresh token available');
      return null;
    }

    const response = await axiosInstance.request({
      url: "/refresh",
      method: "POST",
      data: { refreshToken }
    });

    if (response.data && typeof response.data === 'object' && 'accessToken' in response.data) {
      const newAccessToken = (response.data as any).accessToken;
      // Update the token cookie
      setCookie('token', newAccessToken, 7);
      return newAccessToken;
    }
    
    return null;
  } catch (error) {
    console.error('Error refreshing token:', error);
    return null;
  }
}

function requestWIthAuth<T>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> {

  const token =  getCookie('token');
  const axiosInstanceAuth = axios.create({
    baseURL: baseURL,
    headers: {
      "Content-Type": "application/json",
      "authorization": `Bearer ${token}`, 
    },
  });
  
  console.log('Making API call to:', `${config.method?.toUpperCase() || 'GET'} ${baseURL}${config.url}`);
  if (config.data !== undefined) {
    console.log('Request body:', config.data);
  }
  if (config.params !== undefined) {
    console.log('Request params:', config.params);
  }
  
  axiosInstanceAuth.interceptors.response.use(response => {
    return response;
  }, async error => {
    const originalRequest = error.config;
    
    // Handle 401/403 errors - try to refresh token first
    const requestUrl = String(originalRequest?.url || '');
    const instagramReplyRejected =
      error.response?.status === 403 && requestUrl.includes('/instagram/human-agent');
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403) &&
      !instagramReplyRejected
    ) {
      // Avoid infinite retry loop
      if (originalRequest._retry) {
        // Token refresh failed, redirect to login
        document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        localStorage.removeItem('refreshToken');
        sessionStorage.clear();
        localStorage.removeItem('email');
        window.location.href = '/signin';
        return Promise.reject(error);
      }

      originalRequest._retry = true;

      // Try to refresh the access token
      try {
        const newToken = await refreshAccessToken();
        
        if (newToken) {
          // Update the authorization header with new token
          originalRequest.headers['authorization'] = `Bearer ${newToken}`;
          
          // Retry the original request with new token
          return axiosInstanceAuth(originalRequest);
        } else {
          throw new Error('Failed to refresh token');
        }
      } catch (refreshError) {
        console.error('Token refresh failed:', refreshError);
        // Clear any existing auth data
        document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        localStorage.removeItem('refreshToken');
        sessionStorage.clear();
        localStorage.removeItem('email');
        
        // Redirect to login page
        window.location.href = '/signin';
        return Promise.reject(error);
      }
    }
    
    // For other errors, let components handle them
    return Promise.reject(error);
  });
  return axiosInstanceAuth.request<T>(config);
}
const bookaMeetingApi = { request, requestLocal, requestWIthAuth, API_BASE_AWS, API_BASE_FRONTDESK24 };

export default bookaMeetingApi;
